import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  statistics: {
    //width: '100%',
    //border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.backgroundColor,
    '& tr:first-child td': {
      paddingTop: theme.spacing(2)
    },
    '& tr:last-child td': {
      paddingBottom: theme.spacing(2)
    }
  },
  labelCell: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  valueCell: {
    textAlign: 'right',
    fontStyle: 'italic',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(2)
  },
  iconCell: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1)
  }
}))

export {
  useStyles
}